import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function CEOOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/ceo/overview").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="p-12 text-zinc-500">Loading…</div>;
  const { totals, missions } = data;
  const pct = totals.budget_jh ? (totals.consumed_jh / totals.budget_jh) * 100 : 0;
  return (
    <div className="p-4 md:p-8 lg:p-12 max-w-[1400px]">
      <div className="mb-10">
        <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-3 font-mono">Global · Q{Math.floor(new Date().getMonth()/3)+1}</div>
        <h1 className="font-heading text-5xl font-bold tracking-tight">Firm overview</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
        {[
          ["Clients", totals.clients],
          ["Missions", totals.missions],
          ["Budget (JH)", totals.budget_jh],
          ["Consumed (JH)", totals.consumed_jh],
        ].map(([label, value]) => (
          <div key={label} className="bg-white border border-zinc-200 rounded-lg p-6" data-testid={`ceo-stat-${label}`}>
            <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-3">{label}</div>
            <div className="font-heading text-2xl md:text-4xl font-bold tracking-tight">{value}</div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-zinc-200 rounded-lg p-8 mb-10">
        <div className="flex flex-wrap gap-3 items-baseline justify-between mb-4">
          <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 font-mono">Consumption vs Budget</div>
          <div className="font-mono text-sm">{pct.toFixed(1)}%</div>
        </div>
        <div className="h-2 bg-zinc-100 rounded-full overflow-hidden">
          <div className="h-full bg-zinc-950" style={{ width: `${Math.min(100, pct)}%` }} />
        </div>
        <div className="flex items-center gap-6 mt-6 text-xs font-mono text-zinc-600">
          <div className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-green-600" /> {totals.health.green} on track</div>
          <div className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-amber-500" /> {totals.health.orange} watch</div>
          <div className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-red-600" /> {totals.health.red} at risk</div>
        </div>
      </div>

      <h2 className="font-heading text-xl font-semibold tracking-tight mb-4">All missions</h2>
      <div className="bg-white border border-zinc-200 rounded-lg md:overflow-x-auto md:overflow-hidden">
        <div className="hidden md:grid md:grid-cols-12 md:min-w-[760px] px-5 py-3 text-[10px] uppercase tracking-[0.2em] text-zinc-500 border-b border-zinc-200 font-mono">
          <div className="col-span-4">Mission</div>
          <div className="col-span-2">Client</div>
          <div className="col-span-2">Budget</div>
          <div className="col-span-2">Consumed</div>
          <div className="col-span-2 text-right">Health</div>
        </div>
        {missions.map((m) => {
          const s = m.stats || {};
          const c = { green: "#16A34A", orange: "#F59E0B", red: "#DC2626" }[s.health];
          return (
            <Link key={m.mission_id} to={`/missions/${m.mission_id}`} data-testid={`ceo-mission-${m.mission_id}`} className="flex flex-col gap-2 md:grid md:grid-cols-12 md:items-center md:min-w-[760px] md:gap-0 px-5 py-4 border-b border-zinc-100 last:border-b-0 hover:bg-zinc-50">
              <div className="col-span-4 flex items-center gap-3 min-w-0">
                <div className="w-1 h-8 rounded-full" style={{ background: m.color }} />
                <div className="font-medium truncate">{m.title}</div>
              </div>
              <div className="col-span-2 text-sm truncate">{m.client_name}</div>
              <div className="col-span-2 font-mono text-sm">{s.budget_jh} {m.currency}</div>
              <div className="col-span-2 font-mono text-sm">{s.consumed_jh}</div>
              <div className="col-span-2 text-right flex items-center justify-end gap-2">
                <span className="w-2 h-2 rounded-full" style={{ background: c }} />
                <span className="text-xs uppercase font-mono">{s.health}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
